<template>
  <div>
    <h1>{{ $t("settings.logs.title") }}</h1>
    <v-data-table
      :items="logs"
      :headers="headers"
      :footer-props="{ 'items-per-page-options': [5, 10, 25, 50, 100] }"
      :server-items-length="totalCount"
      :page.sync="pagination.page"
      :sort-desc="pagination.descending"
      :items-per-page.sync="pagination.rowsPerPage"
      :sort-by.sync="pagination.sortBy"
      :loading="$store.getters['Ajax/loading'] ? 'accent' : false"
    >
      <template #item="props">
        <tr>
          <td>{{ props.item.created_at }}</td>
          <td>{{ props.item.userName }}</td>
          <td>{{ props.item.ip }}</td>
          <td>{{ $i18n.locale === "pl" ? props.item.activityNamePl : props.item.activityNameEn }}</td>
          <td>{{ props.item.params }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "SettingsLogsView",
  data: () => ({
    logs: [],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: "created_at"
      //totalItems: number"
    },

    totalCount: null
  }),
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.downloadActivities();
      }
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t("settings.logs.date"), value: "created_at", sortable: false },
        { text: this.$t("settings.logs.user"), value: "user", sortable: false },
        { text: "IP", value: "ip", sortable: false },
        { text: this.$t("settings.logs.activityType"), value: "", sortable: false },
        { text: this.$t("settings.logs.params"), value: "params", sortable: false }
      ];
    },
    locale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    downloadActivities() {
      //this.logs = [];

      this.axios.get("settings/log/get", { params: { page: this.pagination.page, size: this.pagination.rowsPerPage } }).then(resp => {
        this.logs = resp.data.items;
        this.totalCount = resp.data.count;
      });
    }
  },
  created() {
    this.downloadActivities();
  }
};
</script>

<style scoped></style>
